<template>
	<div class="welcome">
		<br>
		<br>
		<center>
			<h1 style="font-weight: bold">{{$t('Whatchat.Title')}}</h1>
			<img :src="commonService.getHomeImageUrl()" alt="" style="width: 50%; margin: auto">
			<p style="font-weight: bold">{{$t('Whatchat.Text1')}}</p>
			<p style="font-weight: bold">{{$t('Whatchat.Text2')}}</p>
			<br />
			<p style="font-weight: bold">{{$t('Whatchat.Text3')}}</p>
		</center>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
};
</script>

<style lang="css" >
.welcome {
	z-index: 123;
}
</style>